<template>
  <div class="documents-new width-responsiveness">
    <modal
      ref="deleteDocumentModal"
      template="loading"
      title="Aguarde"
      ref-name="deleteDocumentModal"
    >
      <p>Excluindo documento.</p>
    </modal>

    <modal
      ref="savingDocumentModal"
      template="loading"
      title="Aguarde"
      ref-name="savingDocumentModal"
    >
      <p>Salvando documento.</p>
    </modal>

    <modal
      ref="questionDeleteDocument"
      template="question"
      title="Excluir documento"
      ref-name="questionDeleteDocument"
      first-button-text="Cancelar"
      second-button-text="Sim"
      :close-button-enabled="true"
      :icon-enabled="false"
      @first-cta="closeQuestionDeleteModal()"
      @second-cta="deleteDocument()"
    >
      <p>Tem certeza que deseja excluir o documento?</p>
    </modal>

    <modal
      ref="updateDocumentModal"
      template="question"
      title="Editar Documento"
      ref-name="updateDocumentModal"
      first-button-text="Cancelar"
      second-button-text="Atualizar"
      :second-button-disabled="theresNoEdition"
      :close-button-enabled="false"
      :icon-enabled="false"
      @first-cta="closeUpdateDocumentModal()"
      @second-cta="updateDocument()"
    >
      <card-form :collapsed="true">
        <div
          slot="expanded"
          class="form-container"
        >
          <md-layout
            :md-gutter="100"
            md-flex="100"
          >
            <md-layout
              md-flex="100"
              class="upload"
            >
              <md-input-container>
                <label>Nome do documento</label>
                <md-input
                  id="fileNameEdit"
                  v-model="edition.fileName"
                  type="text"
                  name="fileNameEdit"
                />
              </md-input-container>
              <md-input-container>
                <label>Substituir arquivo</label>
                <md-file
                  v-model="edition.fileField"
                  @selected="onFileChange"
                />
              </md-input-container>
            </md-layout>
          </md-layout>
        </div>
      </card-form>
    </modal>

    <subheader title="Cadastro de documentos" />
    <card-form :collapsed="true">
      <div
        slot="expanded"
        class="form-container"
      >
        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout
            md-flex="40"
            class="upload"
          >
            <md-input-container>
              <label>Adicionar arquivo</label>
              <md-file
                v-model="creation.fileField"
                @selected="onFileChange"
              />
            </md-input-container>
          </md-layout>
          <md-layout md-flex="40">
            <md-input-container>
              <label>Nome do documento</label>
              <md-input
                id="fileNameNew"
                v-model="creation.fileName"
                type="text"
                name="fileNameNew"
              />
            </md-input-container>
          </md-layout>
          <md-layout
            md-flex="10"
            class="button-container"
          >
            <md-button
              :disabled="isFieldsEmpty"
              class="btn btn-primary btn-regular-size"
              @click="saveDocument()"
            >
              SALVAR
            </md-button>
            <md-tooltip v-if="isFieldsEmpty">
              Todos os campos são obrigatórios
            </md-tooltip>
          </md-layout>
        </md-layout>
      </div>
    </card-form>

    <div class="documents-new__patient width-responsiveness">
      <h2 class="documents-new__patient__title title-main">
        Documentos Cadastrados
      </h2>
    </div>

    <div
      v-if="!loading && documents.length === 0"
      class="empty-cart"
    >
      <img
        src="/static/images/icon-lists.svg"
        alt="Não há documentos cadastrados ainda"
      >
      <h2>Não há documentos cadastrados ainda.</h2>
    </div>

    <documents-list
      v-else
      :get-all-documents="getAllDocuments"
      :loading="loading"
      :documents="documents"
      @delete-document="openQuestionDeleteModal"
      @update-document="openUpdateDocumentModal"
      @download-document="downloadDocument"
    />
  </div>
</template>

<script>
import SubHeader from '@/components/common/SubHeader'
import DocumentsList from './DocumentsNewList'
import CardForm from '@/components/common/CardForm'
import documentManagementService from '@/api/documentManagement'
import notify from '@/api/notification'
import { convertBase64ToFile } from '@/utils/convertBase64ToFile'

export default {
  components: {
    subheader: SubHeader,
    'card-form': CardForm,
    'documents-list': DocumentsList
  },
  data: () => {
    return {
      file: null,
      creation: {
        fileName: '',
        fileField: ''
      },
      edition: {
        fileId: 0,
        fileName: '',
        fileNameOld: '',
        fileField: ''
      },
      documents: [],
      loading: false,
      fileIdToDelete: 0
    }
  },
  computed: {
    isFieldsEmpty: function () {
      return this.file === null || this.creation.fileName === ''
    },
    theresNoEdition: function () {
      return (
        this.file === null && this.edition.fileName === this.edition.fileNameOld
      )
    }
  },
  created () {
    this.getAllDocuments()
  },
  methods: {
    getAllDocuments () {
      this.loading = true
      documentManagementService
        .getAllDocuments()
        .then((response) => {
          this.documents = response.data
          this.loading = false
        })
        .catch(() => {
          notify({
            title: 'AVISO:',
            message: 'Não foi possível carregar os documentos cadastrados.'
          })
          this.loading = false
        })
    },
    downloadDocument (document) {
      notify({
        title: 'AVISO:',
        message: 'Fazendo download...'
      })

      documentManagementService
        .downloadDocumentByUuid(document.uuid)
        .then((response) => {
          let fileName = document.fileName
          let fileExtension = fileName.split('.')[1]
          convertBase64ToFile({
            file: response,
            fileName: fileName,
            fileExtension: fileExtension
          })
          notify({
            title: 'AVISO:',
            message: 'Download realizado com sucesso.'
          })
        })
        .catch(() => {
          notify({
            title: 'AVISO:',
            message: 'Não foi possível fazer download do documento.'
          })
        })
    },
    saveDocument () {
      this.$refs.savingDocumentModal.open()
      documentManagementService
        .sendDocument({
          name: this.creation.fileName,
          file: this.file
        })
        .then((response) => {
          this.$refs.savingDocumentModal.close()
          notify({
            title: 'AVISO:',
            message: 'Documento salvo com sucesso.'
          })
          this.reloadDataTable()
          this.clearFields()
        })
        .catch((error) => {
          this.$refs.savingDocumentModal.close()
          notify({
            title: 'AVISO:',
            message: error.response.data.message
          })
        })
    },
    deleteDocument () {
      this.closeQuestionDeleteModal()
      this.$refs.deleteDocumentModal.open()
      documentManagementService
        .deleteDocument(this.fileIdToDelete)
        .then((response) => {
          this.$refs.deleteDocumentModal.close()
          notify({
            title: 'AVISO:',
            message: 'Documento excluído com sucesso.'
          })
          this.reloadDataTable()
          this.clearFields()
        })
        .catch(() => {
          this.$refs.deleteDocumentModal.close()
          notify({
            title: 'AVISO:',
            message: 'Não foi possível excluir o documento.'
          })
        })
    },
    async updateDocument () {
      let STATUS_UPDATE_NAME
      let STATUS_UPDATE_FILE
      this.$refs.updateDocumentModal.close()
      this.$refs.savingDocumentModal.open()

      if (this.edition.fileNameOld !== this.edition.fileName) {
        await this.updateDocumentName()
          .then(function () {
            STATUS_UPDATE_NAME = 'SUCCESS'
          })
          .catch(function () {
            STATUS_UPDATE_NAME = 'FAILED'
          })
      }
      if (this.file) {
        await this.updateDocumentFile()
          .then(function () {
            STATUS_UPDATE_FILE = 'SUCCESS'
          })
          .catch(function () {
            STATUS_UPDATE_FILE = 'FAILED'
          })
      }

      this.$refs.savingDocumentModal.close()
      if (STATUS_UPDATE_NAME !== 'FAILED' && STATUS_UPDATE_FILE !== 'FAILED') {
        notify({
          title: 'AVISO:',
          message: 'Atualização feita com sucesso!'
        })
      } else {
        notify({
          title: 'AVISO:',
          message: 'Não foi possível salvar suas alterações. Tente mais tarde!'
        })
      }

      this.reloadDataTable()
      this.clearFields()
    },
    updateDocumentName () {
      return documentManagementService.updateDocumentName({
        fileId: this.edition.fileId,
        fileName: this.edition.fileName
      })
    },
    updateDocumentFile () {
      return documentManagementService.updateDocument({
        id: this.edition.fileId,
        file: this.file
      })
    },
    openUpdateDocumentModal (document) {
      this.edition.fileId = document.id
      this.edition.fileName = this.removeExtension(document.fileName)
      this.edition.fileNameOld = this.removeExtension(document.fileName)
      this.$refs.updateDocumentModal.open()
    },
    removeExtension (fileName) {
      return fileName.slice(0, -4)
    },
    closeUpdateDocumentModal () {
      this.clearFields()
      this.$refs.updateDocumentModal.close()
    },
    onFileChange (e) {
      this.file = e[0]
    },
    reloadDataTable () {
      this.documents = []
      this.getAllDocuments()
    },
    clearFields () {
      this.file = null
      this.creation.fileName = ''
      this.creation.fileField = ''
      this.edition.fileName = ''
      this.edition.fileField = ''
      this.edition.fileNameOld = ''
      this.edition.fileId = null
    },
    openQuestionDeleteModal (fileId) {
      this.fileIdToDelete = fileId
      this.$refs.questionDeleteDocument.open()
    },
    closeQuestionDeleteModal () {
      this.$refs.questionDeleteDocument.close()
    }
  }
}
</script>

<style lang="scss">
@import "../../../../../static/stylesheets/mixins";
@import "../../../../../static/stylesheets/variables";
@import "../../../../../static/stylesheets/components/orders/empty-cart";

//Orders New Page Styles
.documents-new {
  margin-top: $headerAndSubHeaderHeight;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 58px);

  .card-form__container {
    transition: min-height 600ms, opacity 600ms;
    opacity: 1;
    border-radius: 6px;
    width: 100%;

    .form-container {
      animation-name: fadein;
      animation-duration: 700ms;
      display: flex;

      .button-container {
        margin: auto;
      }
    }
  }

  .title-main {
    font-size: 12px;
    letter-spacing: 0.1px;
    text-align: start;
    margin-left: -85px;
    color: #7f1a54;
    font-weight: 600;
    text-transform: uppercase;
  }

  .empty-cart {
    margin: 0;
    justify-content: flex-start;
  }

  .md-gutter-24:not(.md-column) {
    margin-right: -12px;
    margin-left: -12px;
    background-color: white;
  }

  &__patient__title {
    margin: 48px 0 30px;
  }

  .md-input-container label {
    font-size: 18px;
  }
}

#updateDocumentModal .md-dialog {
  width: 550px;

  .document-instruction {
    margin-bottom: 0px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 460px;

    span {
      letter-spacing: 0px;
    }
  }
}
</style>
